
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  props: ["time", "timeZone", "timeZoneOffset", "currentTime"],
  data() {
    return {
      remainingDurationText: "",
      timer: null,
      diff: 0,
    };
  },
  watch: {
    currentTime: {
      handler(value) {
        if (!value) {
          return;
        }
        this.diff = Math.round(new Date().getTime() / 1000 - value);
      },
      immediate: true,
    },
  },
  methods: {
    update() {
      let remainingDuration = this.time - moment().unix();
      // if (this.timeZone) {
      //   const serverOffset = this.timeZoneOffset;
      //   const clientOffset = -1 * (new Date().getTimezoneOffset() * 60);
      //   remainingDuration += clientOffset - serverOffset;
      // }
      if (this.currentTime > 0 && this.diff) {
        if (this.diff > 1800 || this.diff < -1800) {
          remainingDuration += this.diff;
        }
      }

      if (remainingDuration < 0) {
        this.remainingDurationText = this.$t(
          "COUNT_DOWN.REMAINING_DURATION_TEXT"
        );
        this.$emit("expiredDuration", true);
      } else {
        this.$emit("expiredDuration", false);
        const hours = Math.floor(
          moment.duration(remainingDuration * 1000).asHours()
        );
        const minutes = moment.duration(remainingDuration * 1000).minutes();
        const seconds = moment.duration(remainingDuration * 1000).seconds();
        this.remainingDurationText =
          this.formatNumberHanlder(hours) +
          ":" +
          this.formatNumberHanlder(minutes) +
          ":" +
          this.formatNumberHanlder(seconds);
      }
    },
    formatNumberHanlder(numb) {
      if (numb < 1) {
        return "00";
      } else if (numb < 10) {
        return "0" + numb;
      } else {
        return numb;
      }
    },
  },
  created() {
    this.update();
    const self = this;
    this.timer = setInterval(() => {
      self.update();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
});
